import { Modal } from '@billy/design-system'
import { ReactElement } from 'react'

import { LegalMentionsType } from '../../../../../../enums/legalMentionsType'
import { LegalMentionsEarlyPaymentDiscount } from './elements/LegalMentionsEarlyPaymentDiscount'
import { LegalMentionsLatePaymentsPenaltyRate } from './elements/LegalMentionsLatePaymentsPenaltyRate'

const legalMentionsContentByType: Record<LegalMentionsType, ReactElement> = {
  [LegalMentionsType.EarlyPaymentDiscount]: <LegalMentionsEarlyPaymentDiscount />,
  [LegalMentionsType.LatePaymentPenaltyRate]: <LegalMentionsLatePaymentsPenaltyRate />,
}

interface LegalMentionsModalBodyProps {
  variant: LegalMentionsType
}

export const LegalMentionsModalBody = ({ variant }: LegalMentionsModalBodyProps) => {
  return <Modal.Body>{legalMentionsContentByType[variant]}</Modal.Body>
}
